import TagInterface from "../../../interfaces/core/TagInterface";

export default function FilterTags({tags, selectedTags, setSelectedTags}:{tags: TagInterface[], selectedTags: TagInterface[], setSelectedTags: Function}) {
    return (<div className="filters__activities">
        <div className="swiper-wrapper">
            {tags.map(tag => <div key={tag.id} className="swiper-slide filters__active">
                <a className={"ico-cont " + (selectedTags.filter(selectedTag => selectedTag.id === tag.id).length ? " active" : "")} href={tag.url} onClick={(event) => {
                event.preventDefault()
                if(selectedTags.filter(selectedTag => selectedTag.id === tag.id).length) {
                    setSelectedTags(selectedTags.filter(selectedTag => selectedTag.id !== tag.id))
                } else {
                    setSelectedTags([...selectedTags, ...[tag]])
                }
            }}>{tag.name}</a></div>)}
            {selectedTags.length > 0 && <div className="swiper-slide filters__active"><a className="ico-cont active" href="/" onClick={(event) => {
                event.preventDefault()
                setSelectedTags([])
            }}>Сбросить все</a></div>}
        </div>
    </div>)
}